import React, {Component} from 'react';
import axios from 'axios';
import { FaCreditCard, FaHome } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import { connect } from 'react-redux';
import { Card, CardBody, Col, Row, Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import paymentBgImage from '../../../assets/img/online-paypment.png';

class PaymentComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            error: false,
            messageError: '',
            btnSubmit: true,
            order: {},
            isNotification: false,
            textNotification: '',
        }
    }

    componentDidMount() {
        this.props.updateUrlRedirect({ url: window.location.href })
        // document.querySelector('.cr-sidebar').classList.remove('cr-sidebar--open');
        window.scrollTo(0, 0);
        this.getDetailOrder(this.props.orderId);
    }

    getDetailOrder = (orderId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/order/getOrderPagePayment/' + orderId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                });
                if (ref.data.error === 0) {
                    this.setState({
                        order: ref.data.order,
                    })
                    let item = {
                        credit: ref.data.credit
                    }
                    this.props.updateCredit(item);
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message ,orderId);
                    }
                    else if ( ref.data.error > 7000 ) {
                        this.redirect(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn đặt hàng thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    redirect = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.shouldRedirect();
    }

    redirectBack = (message, orderId) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.redirectBack(orderId);
    }

    redirectFinish = (message, orderId) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: message
        });
        this.props.redirectBack(orderId);
    }

    paymentOrder = () => {
        this.setState({
            loadPage: true
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = { orderId: this.state.order.id };
        axios.post( process.env.REACT_APP_API_URL + '/api/payment/paymentOrder', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                });
                if (ref.data.error === 0) {
                    this.redirectFinish( ref.data.message, ref.data.orderId );
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message, this.props.orderId);
                    }
                    else if ( ref.data.error > 7000 ) {
                        this.redirect(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn đặt hàng thất bại',
                })
            })
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (

                        <>
                            <BreadcrumbCustomer title={ `Thanh toán đơn đặt hàng`} page={"Thanh toán đơn đặt hàng"} icon={<MdPayment className="breadcrumb-icon"/>} />
                            <Row>
                                <Col md={12} lg={8} xl={6} className="text-center mx-auto">
                                    <Card className="mt-5 payment" >
                                        <div className="payment-background-card" style={{ backgroundImage: `url(${paymentBgImage})` }} />
                                        <CardBody>
                                            <Row>
                                                <Col md={12} className="text-center">
                                                    <h4 className="mb-4 text-primary">Thanh toán bằng số dư tài khoản</h4>
                                                </Col>
                                                <Col md={12}>
                                                    <div className="payment-info text-center">
                                                        {
                                                            this.state.error ? (
                                                                <Alert color="danger" className="text-center">
                                                                    { this.state.messageError }
                                                                </Alert>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        <div className="info-company text-center mt-4">
                                                            <b>Số dư tài khoản: </b> <b className="text-success">{ this.addCommas( this.props.credit ) } ₫</b> <br/>
                                                            <b>Tổng số tiền thanh toán: </b> <b className="text-danger">{ this.state.order.text_total } ₫</b> <br/>
                                                            <b>Loại giao dịch: </b> <b className="text-primary">{ this.state.order.text_type_order }</b> <br/>
                                                            {
                                                                this.props.credit >= this.state.order.total ? (
                                                                    <button className="btn btn-success mt-4 mb-4" onClick={ () => this.paymentOrder() }>
                                                                        <FaCreditCard /> Thanh toán
                                                                    </button>
                                                                ) : (
                                                                    <Link to={'/quan-ly-giao-dich/nap-tien-tai-khoan.html'}  className="btn btn-danger m-1">Nạp tiền tài khoản</Link>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                                
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="text-center mt-4 mb-4">
                                        <Link to={"/"}>
                                            <button className="btn btn-default"><FaHome /> Trở về trang chủ </button>
                                        </Link>
                                    </div>
                                </Col>
                            </Row>
                            
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerPayment' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PaymentComponent);